export const TOGGLE_SELECTED_ITEM = 'TOGGLE_SELECTED_ITEM';
export const RESET_SELECTED_ITEM = 'RESET_SELECTED_ITEM';
export const SET_CACHE_BUST = 'SET_CACHE_BUST';
export const SET_GLOBAL_META = 'SET_GLOBAL_META';
export const SAVE_META = 'SAVE_META';
export const RESTORE_META = 'RESTORE_META';

export const toggleSelectedItem = ( id ) => {
	return {
		type: TOGGLE_SELECTED_ITEM,
		id
	}
};

export const resetSelectedItem = () => {
	return {
		type: RESET_SELECTED_ITEM
	}
};

export const setCacheBuster = ( cacheBust ) => {
	return {
		type: SET_CACHE_BUST,
		cacheBust
	}
};

export const getCacheBuster = ( getState ) => {
	return getState().meta.cacheBust
};

export const receiveGlobalMeta = (meta, title, subTitle) => {
	return {
		type: SET_GLOBAL_META,
		meta: meta,
		title: title,
		subTitle: subTitle
	};
};

export const saveMeta = () => {
	return {
		type: SAVE_META
	}
};

export const restoreMeta = () => {
	return {
		type: RESTORE_META
	}
};


// WEBPACK FOOTER //
// ./common/actions/MetaActions.js